import { render, staticRenderFns } from "./NotificationPopover.vue?vue&type=template&id=2b2a98b3&scoped=true&"
import script from "./NotificationPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopover.vue?vue&type=style&index=0&id=2b2a98b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a98b3",
  null
  
)

export default component.exports